<mat-nav-list>
    <ng-container *ngFor="let method of paymentMethods">
        <a mat-list-item (click)="selectMethod(method)" *ngIf="method.name!=='Stripe Card Reader'">
            <span mat-line class="method-item">
                <mat-icon>{{ method.title === 'Card Payment' ? 'payment' : 'account_balance_wallet' }}</mat-icon>
                {{ method.title === 'Card Payment' ? ('PAYMENT.ONLINE' | translate) : ('PAYMENT.CASH' | translate) }}
            </span>

            <span>
                {{ 'PAYMENT.AMOUNT' | translate:{ amount: (data.totalAmount + calculateProcessingFee(method.title)) |
                currency:basicInfo.currencyCode } }}
            </span>

        </a>
    </ng-container>
</mat-nav-list>